/**
 * Copiar para a área de transferência, com queda suave.
 *
 * `navigator.clipboard` é **exclusivo de contexto seguro** e some quando o
 * produto é aberto pelo IP da máquina na rede do salão
 * (`http://192.168.0.12:5173`) — que é ambiente real de uso, não exceção.
 * Sem o fallback, o botão "Copiar" simplesmente não faria nada ali, e o link
 * do convite não sairia da tela.
 *
 * A reserva é o truque antigo do `<textarea>` + `document.execCommand`, que
 * é obsoleto mas funciona em http. Se nem ele funcionar, devolvemos `false`
 * e a tela mostra o link **selecionado**, pronto para o Ctrl+C — porque uma
 * mensagem de "não deu" sem saída é pior do que um passo manual.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Permissão negada ou contexto inseguro: cai para a reserva.
  }

  try {
    const area = document.createElement('textarea');
    area.value = text;
    // Fora da tela, mas focável: `display:none` não é selecionável.
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    area.style.opacity = '0';

    document.body.appendChild(area);
    area.select();

    const ok = document.execCommand('copy');
    document.body.removeChild(area);

    return ok;
  } catch {
    return false;
  }
}

/** Seleciona o texto de um campo, para quem vai copiar à mão. */
export function selectAll(element: HTMLInputElement | HTMLTextAreaElement | null): void {
  if (!element) return;
  element.focus();
  element.select();
  element.setSelectionRange(0, element.value.length);
}
